import React, { useEffect, useState } from "react";
import { useHistory } from 'react-router-dom';
import styles from "../../assets/containers/lessonCard.module.css";
import { ArrowRightIcon } from "../../assets/icons/ArrowRight.js";
import {useAppGlobalConfig} from "../../providers/AppGlobalConfigContext";
import { getUserId } from "../../helpers/user";
import { getUsageWithFallback } from "../../helpers/progressFallback";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";

const LessonCard = props => {

  const {isEmbedMode, fireNavigationEvents} = useAppGlobalConfig();
  const { lesson, groupIndex, bookProgress } = props;
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [tenant, setTenant] = useState();
  const [isComplete, setIsComplete] = useState(false);

  const handleLessonClick = async (lessonId) => {
    setIsLoading(true);

    let blockIndex = 0;
    try {
      const userInfo = JSON.parse(localStorage.getItem("user-info"));
      const usageProgressTrackerData = await getUsageWithFallback(userInfo.id, lessonId, tenant);
      const usage = (usageProgressTrackerData && usageProgressTrackerData.data) || {};
      // Fresh lesson (no usage record yet) → keep blockIndex at 0 instead of Math.max([]) = -Infinity.
      if (!usage.notFound && Array.isArray(usage.progress) && usage.progress.length > 0) {
        const biggestIndex = Math.max(...usage.progress);
        const totalSections = usage.totalSections || 0;
        blockIndex = (biggestIndex === totalSections - 1) ? biggestIndex : biggestIndex + 1;
      }
    } catch (err) {
      if (err && err.status !== 404) {
        console.log("error getting student metrics: ", err);
        return;
      }
    } finally {
      if(!isEmbedMode) localStorage.removeItem('lessons');
      setIsLoading(false);

      const location = `${isEmbedMode ? '/embeddable' : ''}/catchupId/1/lesson/${lessonId}/${blockIndex}`;
      localStorage.setItem('lessonName', lesson.name);
      history.push(location);

    }
  };

  const checkCompleteness = async () => {
    const userId = await getUserId();
    try {

      getUsageWithFallback(userId, lesson.id, tenant)
          .then((usage) => {
            const data = (usage && usage.data) || {};
            const total = data.totalSections || 0;
            const progressLength = Array.isArray(data.progress) ? data.progress.length : 0;
            setIsComplete(!data.notFound && total > 0 && progressLength === total);
          })
          .catch(() => { setIsComplete(false); });

    } catch (err) {
      console.log("Error getting lesson ", lesson.name, ":", err.message);
      setIsComplete(false);
    }
  }

  useEffect(() => {
    isEmbedMode ? setTenant("cupheadless") : setTenant("cupfranchise")
  }, []);

  useEffect(() => {
    isEmbedMode ? setTenant("cupheadless") : setTenant("cupfranchise")
  }, [isEmbedMode]);

  useEffect(() => {
    if (!lesson.id || !tenant) return;

    if (bookProgress !== undefined) {
      // ARTFRAN-15305: use the consolidated payload provided by <Book /> and skip the per-lesson call.
      if (!bookProgress.isLoaded) return;
      const usage = bookProgress.lessonsById[lesson.id];
      const progressLength = usage && Array.isArray(usage.progress) ? usage.progress.length : 0;
      const total = usage ? usage.totalSections : 0;
      setIsComplete(total > 0 && progressLength === total);
      return;
    }

    checkCompleteness();
  }, [lesson.id, tenant, bookProgress]);

  return (
    <>
      <div key={groupIndex} className={styles["lesson-card"]}>
        {isLoading ? (
          <div className={styles["spinner-container"]}>
            <div className="spinner-border">
            </div>
          </div>
        ) : (
          <div className={styles["card-content"]}>
            <h2 className={styles["card-title"]}>{lesson.name}</h2>
            <div 
              className={styles["card-link"]}
              onClick={() => handleLessonClick(lesson.id)}>
                Start Lesson <ArrowRightIcon className={styles["arrow-icon"]}/>
            </div>
            <div className={styles["card-completeness"]}>
              {isComplete && (
                  <>
                    <FontAwesomeIcon icon={faCheckCircle} size={"xs"} className={styles["card-completeness-icon"]} />
                    <span className={styles["card-completeness-text"]}>Completed</span>
                  </>
              )}
            </div>
          </div>
        )}
      </div> 
    </>
  );
};

export default LessonCard;
